import React from 'react'
import Icon from '../../misc/Icons'
import { getEmailEditButtonStyle } from '../../../utils/emailVerificationQA'
import useEmailVerificationQASetting from '../../../utils/emailVerification/useEmailVerificationQASetting'

// An address in the offer screens' email box, with an edit button on its
// right that starts updating that address. onEdit omitted (e.g. once the
// screen is showing its confirmed state) hides the button.
const EmailVerificationEmailRow = (props) => {
  const { email, onEdit, editAriaLabel } = props
  // the QA panel can switch the edit button's look while this is on screen
  const editButtonStyle = useEmailVerificationQASetting(getEmailEditButtonStyle)
  const showIcon = editButtonStyle === 'pencil' || editButtonStyle === 'pencilText'
  const showLabel = editButtonStyle !== 'pencil'

  return (
    <div className='emailVerificationFlow-emailBox-row'>
      <div className='emailVerificationFlow-emailDisplay'>{email}</div>
      {onEdit && (
        <button
          type='button'
          className={`emailVerificationFlow-emailBox-editBtn emailVerificationFlow-emailBox-editBtn--${editButtonStyle}`}
          onClick={onEdit}
          aria-label={editAriaLabel}
        >
          {showIcon && <Icon name='pencil' />}
          {showLabel && <span className='emailVerificationFlow-emailBox-editBtn-label'>Edit</span>}
        </button>
      )}
    </div>
  )
}

export default EmailVerificationEmailRow
